import React from 'react';
import { TableWrapper, StyledBaseTable } from './styled';
import { AutoResizer } from 'react-base-table';

function Table({ style = {}, ...tableProps }) {
  return (
    <TableWrapper style={style}>
      <AutoResizer>
        {({ width, height }) => (
          <StyledBaseTable
            width={width}
            height={height}
            {...tableProps}
          />
        )}
      </AutoResizer>
    </TableWrapper>
  )
}

export default Table;
